import React from 'react'
import { List, ListItem, ListItemText, Skeleton } from '@mui/material'
import { times } from 'lodash'

interface RequiredQualificationsListSkeletonProps {
  qualificationsCount: number
}

const RequiredQualificationsListSkeleton: React.FC<RequiredQualificationsListSkeletonProps> = ({
  qualificationsCount,
}) => {
  return (
    <List component='ul' sx={{ padding: 0, pl: 2 }}>
      {times(qualificationsCount, (index) => (
        <ListItem
          key={index}
          component='li'
          disableGutters
          sx={{
            alignItems: 'flex-start',
            padding: 0,
            display: 'list-item',
            listStyleType: 'disc',
            listStylePosition: 'outside',
          }}
        >
          <ListItemText primary={<Skeleton variant='text' width='60%' sx={{ fontSize: '16px' }} />} />
        </ListItem>
      ))}
    </List>
  )
}

export default RequiredQualificationsListSkeleton
